import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import { client } from '../client'
import emptyDrink from '../images/emptyDrink2.svg'

const DrinksMenu = ({ isEng, isFood, products, selectedCat, setSelectedCat, categories }) => {

   

    function filterProducts(prods) {
        if (selectedCat === '' && products !== null) {
              
                let produkts = prods.sort((a, b) =>{ 
                    a.publishedAt = new Date(a.publishedAt)
                    b.publishedAt = new Date(b.publishedAt)
                       
                    return b?.publishedAt - a?.publishedAt} )
            
            return produkts
        } else {
            let filteredData = []
            for (let prod of prods) {
                if (prod.drinksCategory?.title === selectedCat) {
                    prod.publishedAt = new Date(prod.publishedAt);
                    filteredData.push(prod)
                }
            }
            filteredData = filteredData.sort((a,b) => b?.publishedAt - a?.publishedAt)
            console.log(filteredData)
            return filteredData
        }

    }
    let filteredProducts = []
    if (products !== null) {
        filteredProducts = filterProducts(products)
    }


    return (
        <AnimatePresence>
            {!isFood &&
                <motion.div
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -300, opacity: 0 }}
                     className='w-full m-auto mb-[80px] text-center leading-[1rem] '>
                    <div className='relative categories text-greenTwo flex flex-row justify-center mb-2  '>
                        {/* <h1 className='absolute top-0 left-6 sm:left-14 md:left-40 sm:text-2xl text-xl font-bold'>
                            {!isEng ? "Изберете категория:" : "Category"}</h1>
                        <div
                            onClick={() => { setSelectedCat('') }}
                            className={`cursor-pointer w-1/4 rounded-md flex items-center  justify-center ${selectedCat === '' ? 'bg-blueThree text-greenOne text-lg'
                                : ' bg-greenOne text-greenTwo'}  text-center italic p-1   text-base `}>
                            <p>{!isEng ? "Всички" : "All"}</p>
                        </div> */}
                    </div>
                    {/* Category picker */}
                    <div className='w-full flex flex-wrap gap-y-[0.3rem] gap-x-[1px] justify-around mt-1 text-lg  font-bold'>
                        {categories && categories.map(category =>
                            <div
                                onClick={() => {
                                    setSelectedCat(category.title)
                                }}
                                key={category.importance}
                                className={`cursor-pointer w-1/6 h-[40px] leading-[1rem] rounded-md flex items-center justify-center 
                                ${selectedCat === category.title
                                        ? ' bg-blueThree text-greenOne ' : 'bg-greenOne text-greenTwo'}  text-center italic p-1 `}>
                                <p>{!isEng ? category.title : category.title_eng}</p>
                            </div>)}


                    </div>
                    {/* SHOWCASE */}
                    <div className='w-11/12 m-auto mt-6 sm:flex sm:flex-wrap sm:flex-row text-center'>
                        {/* EACH PRODUCT */}
                        {filteredProducts.length === 0 &&
                            <p className='text-blueThree text-xl italic mx-auto'>
                                {!isEng ? "Зареждаме наличните продукти..." : "We are loading..."}
                            </p>}
                        {filteredProducts && filteredProducts.map(product =>

                            <div key={product.slug.current} className='flex flex-col  border-b-0 h-[380px] w-full sm:w-1/2  lg:w-1/3 '>
                                <div className='border  border-black border-b-0 h-[320px] border-opacity-60 text-greenTwo overflow-hidden'>
                                    <div className='h-[320px] w-full overflow-hidden  border-black'>
                                        <motion.img
                                            initial={{ scale: 0.7 }}
                                            whileInView={{ scale: 1 }}
                                            whileTap={{ scale: 1.5 }}
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ duration: 0.3 }}
                                            className=' object-contain  w-full p-2 h-full' src={(product.mainImage?.asset?.url &&                                               
                                                    product.mainImage?.asset?.url +'?auto=format&w=1200') || emptyDrink}>

                                        </motion.img>
                                    </div>
                                </div>
                                {/* TITLE AND DESCRIPTION */}
                                <div className='border  border-t-0 pb-3   border-black border-opacity-60 text-greenTwo overflow-hidden'>
                                    <div className='z- w-full p-[1px] self-start ml-2 text-xl flex justify-around items-center'>
                                        <div className='w-9/12 flex flex-col'>
                                            <h1 className='text-3xl'>{!isEng ? product?.title : product.title_eng}
                                                {product.weight && `- ${product?.weight}${!isEng ? "мл." : "ml."}`}</h1>
                                            {/* DESCRIPTION */}
                                            {/* <div className='prose flex flex-col italic justify-start items-start ml-4 text-xl'>
                                                <p className='text-blueThree'>{!isEng ? "Описание:" : "Description:"}</p>
                                                <div className='mb-4'>
                                                    <p>{!isEng ? product.body : product.body_eng}</p>
                                                </div>
                                            </div> */}
                                        </div>

                                        <div className='h-[60px] w-[60px] mr-2 border border-[#2a5d80] rounded-full bg-greenOne flex flex-col justify-center items-center'>
                                            <p>{(product.price / 1.95583).toFixed(2)}€</p>
                                            {/* <p>{product?.price}{!isEng ? "лв." : "bgn."}</p> */}
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt-6 text-2xl italic pb-4 text-greenTwo'>
                        {filteredProducts.length !== 0 &&
                            <h1>{!isEng ? "Достигнахте до края на тази категория." : "You reached the end of this category"} </h1>}

                    </div>
                </motion.div>}
        </AnimatePresence>
    )
}

export default DrinksMenu